import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import LabelInput from "../../../../shared/components/labelInput";
import RadioGroup from "../../../../shared/components/RadioGroup";
import Button from "../../../../shared/components/Button";
import quoteUpdateMapper from "../../mappers/quoteUpdateMapper";
import { EditQuoteDetails, handleNext } from "../../../../shared/utils/navigationUtils";
import { fetchPanelData, saveQuote } from "../../services/quoteService";
import useQuoteStore from "../../store/QuoteStore";
import { useNavigate } from "fusion-plugin-react-router";
import { volentryExcess } from "../../../../shared/services/simpleListItemsService";
import QuoteStep from "../../enums/QuoteStep";

const TqPanelUpdateForm = ({
  STATE,
  bonusValue,
  useInternalBonus = true,
  buttonSize,
  className,
  buttonGroupClassName = "tw-mt-5 tw-flex tw-flex-col tw-gap-3",
}) => {
  const {
    register,
    formState: { errors },
    watch,
    handleSubmit,
    control,
    trigger,
  } = useForm({
    defaultValues: quoteUpdateMapper.get(),
  });
  const [optionsExcess, setOptionsExcess] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    volentryExcess().then((statuses) => setOptionsExcess(statuses));
  }, []);

  const convertArrayFormat = (array) => {
    if (!Array.isArray(array)) {
      console.error("convertArrayFormat: Input is not an array");
      return [];
    }

    return array.map((item) => ({
      value: item.listItemId || "0",
      label: `£${item.listItemDescription || "00"}`,
    }));
  };

  const updateQuoteResults = (data) => {
    quoteUpdateMapper.set(data);
    STATE.setShowModel(false);

    const quoteData = useQuoteStore.getState().quote;
    saveQuote(quoteData, navigate).then((savedQuote) => {
      fetchPanelData(navigate, null, savedQuote.risk.riskObjectId).then(() => {
        handleNext(QuoteStep.TQ_PANEL, STATE);
      });
    });
    handleNext(QuoteStep.TQ_PANEL_LOADER, STATE);
  };

  const showBonusProtection = useInternalBonus
    ? watch("bonus")?.value > 1
    : bonusValue > 1;

  return (
    <form
      onSubmit={handleSubmit(updateQuoteResults)}
      className={className}
    >
      <LabelInput
        id="volAccess"
        label="Voluntary Excess"
        type="select"
        placeholder="£0"
        options={convertArrayFormat(optionsExcess)}
        register={register("volAccess", { required: "Required" })}
        errors={errors.volAccess}
        watch={watch("volAccess")}
        control={control}
        trigger={trigger}
      />
      {showBonusProtection && (
        <RadioGroup
          name="claimBonus"
          mainLabel="Would you like to protect your no claims bonus?"
          register={register}
          trigger={trigger}
          errors={errors.claimBonus}
        />
      )}
      <div className={buttonGroupClassName}>
        <Button type="submit" variant="main" size={buttonSize} fullWidth>
          Update Quote Results
        </Button>
        <Button
          onClick={() => EditQuoteDetails()}
          type="button"
          variant="soft"
          size={buttonSize}
          fullWidth
        >
          Edit Quote Details
        </Button>
      </div>
    </form>
  );
};

export default TqPanelUpdateForm;
